import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@recruitee/i18n';
import { EditorJSONState } from '@recruitee/prosemirror-types';
import { RenderDirective } from '@recruitee/prosemirror/angular';
import {
  ProsemirrorDefaultConfig,
  ProsemirrorDefaultConfigDirective,
  WysiwygComponent,
} from '@recruitee/prosemirror/webapp';
import {
  BadgeComponent,
  BoxComponent,
  FormFieldComponent,
  HeadingComponent,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-requisitions-context-form',
  templateUrl: './requisitions-context-form.component.html',
  styleUrls: ['./requisitions-context-form.component.less'],
  imports: [
    BoxComponent,
    FormFieldComponent,
    HeadingComponent,
    BadgeComponent,
    TranslatePipe,
    ReactiveFormsModule,
    WysiwygComponent,
    RenderDirective,
    ProsemirrorDefaultConfigDirective,
  ],
})
export class RequisitionsContextFormComponent {
  @Input() public generalContextControl: FormControl<EditorJSONState | object | null>;
  @Input() public isFormEditable: boolean;

  public ProsemirrorConfig = ProsemirrorDefaultConfig;
}
